(function () {
  if (window.neoMarketStarted) return;
  window.neoMarketStarted = true;
  var storeKey = 'neo-market-favourites-v1';
  var favourites = [];
  try { favourites = JSON.parse(localStorage.getItem(storeKey) || '[]'); } catch (error) {}
  if (!Array.isArray(favourites)) favourites = [];
  favourites = favourites.filter(function (item) { return item && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//') && typeof item.title === 'string'; });
  function ui() { return document.querySelector('[data-neo-market-ui]'); }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function saveFavourites() { try { localStorage.setItem(storeKey, JSON.stringify(favourites)); } catch (error) {} refreshFavourites(); }
  function refreshFavourites() {
    var shell = ui();
    if (!shell) return;
    document.querySelectorAll('[data-neo-save]').forEach(function (button) {
      var saved = favourites.some(function (item) { return item.url === button.dataset.neoSave; });
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? shell.dataset.savedLabel : shell.dataset.saveLabel) + ': ' + button.dataset.title);
    });
    var list = shell.querySelector('[data-neo-favourites-list]');
    var empty = shell.querySelector('[data-neo-favourites-empty]');
    empty.hidden = favourites.length > 0;
    list.replaceChildren();
    favourites.forEach(function (item) {
      var row = document.createElement('div');
      var link = document.createElement('a');
      link.href = item.url;
      if (item.image && /^https?:\/\//.test(item.image)) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = '';
        image.width = 65;
        image.height = 65;
        image.loading = 'lazy';
        link.appendChild(image);
      }
      var title = document.createElement('span');
      title.textContent = item.title;
      link.appendChild(title);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.neoRemove = item.url;
      remove.setAttribute('aria-label', shell.dataset.removeLabel + ': ' + item.title);
      remove.textContent = '×';
      row.append(link, remove);
      list.appendChild(row);
    });
  }
  function addFavouriteButtons() {
    if (!document.body.classList.contains('neo-market-home') && !document.body.classList.contains('neo-collection')) return;
    var source = document.querySelector('[data-neo-open="favourites"] svg');
    if (!source) return;
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var media = card.querySelector('.card__inner');
      var link = card.querySelector('.card__heading a');
      var image = card.querySelector('.card__inner img');
      if (!media || !link || media.querySelector('[data-neo-save]')) return;
      var url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'neo-market-favourite-toggle';
      button.dataset.neoSave = url.pathname;
      button.dataset.title = link.textContent.trim();
      button.dataset.image = image ? new URL(image.currentSrc || image.src, location.origin).href : '';
      button.appendChild(source.cloneNode(true));
      media.appendChild(button);
    });
    refreshFavourites();
  }
  function openDialog(name) {
    var dialog = document.querySelector('[data-neo-dialog="' + name + '"]');
    if (!dialog) return;
    if (name === 'favourites') refreshFavourites();
    if (!dialog.open) dialog.showModal();
    document.querySelectorAll('[data-neo-open="' + name + '"]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
  }
  function findChatButton() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    var runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
    return runtime && runtime.shadowRoot ? runtime.shadowRoot.querySelector('button[part="activator"]') : host.shadowRoot.querySelector('button');
  }
  function openChat() {
    var launcher = findChatButton();
    if (launcher) {
      if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
      return;
    }
    openDialog('contact');
  }
  function setupCarousel(carousel) {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    var track = carousel.querySelector('.neo-market-slides');
    var slides = Array.from(track.querySelectorAll('[data-neo-slide]'));
    var dots = Array.from(carousel.querySelectorAll('[data-neo-dot]'));
    var previous = carousel.querySelector('[data-neo-prev]');
    var next = carousel.querySelector('[data-neo-next]');
    var status = carousel.querySelector('[data-neo-slide-status]');
    var index = 0;
    function update() {
      var start = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
      var closest = Infinity;
      slides.forEach(function (slide, current) {
        var distance = Math.abs(slide.getBoundingClientRect().left - start);
        if (distance < closest) { closest = distance; index = current; }
      });
      dots.forEach(function (dot, current) { if (current === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      status.textContent = (index + 1) + ' / ' + slides.length;
    }
    function go(target) {
      target = Math.max(0, Math.min(slides.length - 1, target));
      var padding = parseFloat(getComputedStyle(track).paddingLeft);
      var left = track.scrollLeft + slides[target].getBoundingClientRect().left - track.getBoundingClientRect().left - padding;
      track.scrollTo({left: left, behavior: reducedMotion() ? 'auto' : 'smooth'});
    }
    previous.addEventListener('click', function () { go(index - 1); });
    next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (dot, current) { dot.addEventListener('click', function () { go(current); }); });
    var frame;
    track.addEventListener('scroll', function () { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive: true});
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1)); }
      if (event.key === 'Home') { event.preventDefault(); go(0); }
      if (event.key === 'End') { event.preventDefault(); go(slides.length - 1); }
    });
    var startX = 0, startLeft = 0, dragging = false, moved = false;
    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      startX = event.clientX; startLeft = track.scrollLeft; dragging = true; moved = false;
    });
    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      if (Math.abs(event.clientX - startX) > 7) {
        moved = true; track.classList.add('is-dragging'); event.preventDefault(); track.scrollLeft = startLeft - (event.clientX - startX);
      }
    });
    track.addEventListener('dragstart', function (event) { event.preventDefault(); });
    function endDrag() { if (!dragging) return; dragging = false; track.classList.remove('is-dragging'); if (moved) { update(); go(index); } }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', function (event) { if (moved) { event.preventDefault(); event.stopPropagation(); moved = false; } }, true);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  }
  function init() {
    document.querySelectorAll('[data-neo-carousel]').forEach(setupCarousel);
    document.querySelectorAll('[data-neo-dialog]').forEach(function (dialog) {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('close', function () {
        document.querySelectorAll('[data-neo-open="' + dialog.dataset.neoDialog + '"]').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) { var rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
    });
    addFavouriteButtons();
  }
  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-neo-open]');
    if (open) { event.preventDefault(); openDialog(open.dataset.neoOpen); return; }
    var close = event.target.closest('[data-neo-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (event.target.closest('[data-neo-chat]')) { event.preventDefault(); openChat(); return; }
    var dismiss = event.target.closest('[data-neo-dismiss-trust]');
    if (dismiss) { dismiss.closest('.neo-market-trust').hidden = true; return; }
    var save = event.target.closest('[data-neo-save]');
    if (save) {
      event.preventDefault(); event.stopPropagation();
      var exists = favourites.some(function (item) { return item.url === save.dataset.neoSave; });
      if (exists) favourites = favourites.filter(function (item) { return item.url !== save.dataset.neoSave; });
      else favourites.push({url: save.dataset.neoSave, title: save.dataset.title, image: save.dataset.image ? new URL(save.dataset.image, location.origin).href : ''});
      saveFavourites(); return;
    }
    var remove = event.target.closest('[data-neo-remove]');
    if (remove) { favourites = favourites.filter(function (item) { return item.url !== remove.dataset.neoRemove; }); saveFavourites(); }
  });
  function updateCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-neo-cart-count]').forEach(function (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
  }
  function refreshCount() { fetch((window.routes && window.routes.cart_url || '/cart') + '.js', {headers:{'Accept':'application/json'}}).then(function (response) { return response.ok ? response.json() : null; }).then(updateCount).catch(function () {}); }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) { if (event && event.cartData && typeof event.cartData.item_count === 'number') updateCount(event.cartData); else refreshCount(); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) refreshCount(); });
  window.addEventListener('storage', function (event) { if (event.key === storeKey) { try { var value = JSON.parse(event.newValue || '[]'); favourites = Array.isArray(value) ? value : []; refreshFavourites(); } catch (error) {} } });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

